import { render, staticRenderFns } from "./KAMFormCreate.vue?vue&type=template&id=235170a4&scoped=true"
import script from "./KAMFormCreate.vue?vue&type=script&lang=ts"
export * from "./KAMFormCreate.vue?vue&type=script&lang=ts"
import style0 from "./KAMFormCreate.vue?vue&type=style&index=0&id=235170a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235170a4",
  null
  
)

export default component.exports